import React, { useState, useEffect } from "react";
import { NewsItemType, NewsItemPicturetype } from "../../Types/News";
import moment from 'moment';
import Loading from "../Loading";

type Props = {
    startTime: any,
    duration: number,
    onTimerFinished?: () => any | null,
    isProcessing?: boolean
}

const Timer = ({ startTime, duration, onTimerFinished, isProcessing }: Props) => {

    const [timerData, setTimerData] = useState({ // данные таймера
        hours: "00",
        minutes: "00",
        seconds: "00"
    })
    const [timeEnd, setTimeEnd] = useState(false); // Конец таймера
    const [isTimerRunning, setIsTimerRunning] = useState(false); // Флаг запуска таймера

    useEffect(() => {
        if (!startTime || !duration) return;

        setIsTimerRunning(true); 

        // Вычисляем точку окончания один раз
        const endTime = new Date(new Date(startTime).getTime() + duration * 60 * 1000);
        console.log("endTime", endTime);

        const interval = setInterval(() => {
            const now = new Date();
            const diff = Math.floor((endTime.getTime() - now.getTime()) / 1000);

            if (diff <= 0) {
                clearInterval(interval);
                setTimerData({ hours: "00", minutes: "00", seconds: "00" });
                setTimeEnd(true);
                return;
            }

            const hours = Math.floor(diff / 3600);
            const minutes = Math.floor((diff % 3600) / 60);
            const seconds = diff % 60;

            setTimerData({
                hours: String(hours).padStart(2, "0"),
                minutes: String(minutes).padStart(2, "0"),
                seconds: String(seconds).padStart(2, "0"),
            });
        }, 1000);

        // Очистка интервала при размонтировании или изменении зависимостей
        return () => clearInterval(interval);
    }, [startTime, duration])
    
    const getVisible = (percent) => {
        const r = 25;
        const circumference = 2 * Math.PI * r;

        const visible = (percent / 100) * circumference;
        const gap = circumference - visible;
        return visible;
    }

    const getGap = (percent) => {
        const r = 25;
        const circumference = 2 * Math.PI * r;

        const visible = (percent / 100) * circumference;
        const gap = circumference - visible;

        return gap;
    }

    useEffect(() => {
        if (onTimerFinished && timeEnd && isTimerRunning) {
            setIsTimerRunning(false);
            onTimerFinished();
        }
    }, [timeEnd, timerData]);


    return (
        <div className="timerWrapper">
            {isProcessing && <div>
                <Loading /> 
                <div>Обновление данных...</div>
            </div>}
            <div className="timer">
                <div className="hours item">
                    <span>{timerData.hours}</span>
                    <div className="shadow"></div>
                    <svg width="60" height="60">
                        <circle
                            style={{ transition: 'stroke-dasharray 0.5s ease-out' }}
                            cx="30"
                            cy="30"
                            r="25"
                            stroke="#B200FF"
                            strokeWidth="4"
                            fill="none"
                            strokeDasharray={`${getVisible((Number(timerData.hours) / (duration / 60)) * 100)} ${getGap((Number(timerData.hours) / (duration / 60)) * 100)}`}
                            transform="rotate(-90 30 30)"
                        />
                    </svg>
                </div>
                <div className="minutes item">
                    <span>{timerData.minutes}</span>
                    <div className="shadow"></div>
                    <svg width="60" height="60">
                        <circle
                            style={{ transition: 'stroke-dasharray 0.5s ease-out' }}
                            cx="30"
                            cy="30"
                            r="25"
                            stroke="#B200FF"
                            strokeWidth="4"
                            fill="none"
                            strokeDasharray={`${getVisible((Number(timerData.minutes) / duration) * 100)} ${getGap((Number(timerData.minutes) / duration) * 100)}`}
                            transform="rotate(-90 30 30)"
                        />
                    </svg>
                </div>
                <div className="seconds item">
                    <span>{timerData.seconds}</span>
                    <div className="shadow"></div>
                    <svg width="60" height="60">
                        <circle
                            style={{ transition: 'stroke-dasharray 0.5s ease-out' }}
                            cx="30"
                            cy="30"
                            r="25"
                            stroke="#B200FF"
                            stroke-width="4"
                            fill="none"
                            stroke-dasharray={`${getVisible((Number(timerData.seconds) / 60) * 100)} ${getGap((Number(timerData.seconds) / 60) * 100)}`}
                            transform="rotate(-90 30 30)"
                        />
                    </svg>
                </div>
            </div>
        </div>
    )
} 

export default Timer;